// Pure helpers for the votes slider's per-media-type scaling. Kept free of
// React/MUI/axios so they can be unit-tested in isolation (see voteScale.test.js).
// Consumed by Search.js; see docs/dual-mode-mechanics.md for the wider context.

export const VOTE_STEP_INCREMENTS = [
  1000, 5000, 10000, 25000, 50000, 100000, 200000, 250000, 500000,
];

// Target ~20 notches across the range (touch-friendly on mobile), snapped up to
// a "nice" increment. Lower cap = coarser steps = bigger finger targets.
export const MAX_VOTE_STEPS = 20;

export const niceVoteStep = (max) => {
  const raw = max / MAX_VOTE_STEPS;
  return VOTE_STEP_INCREMENTS.find((n) => n >= raw) ?? Math.ceil(raw / 100000) * 100000;
};

// Vote ceiling for the current selection: max over the backend types of the
// selected UI groups (all groups when none selected). Floored so step != 0.
export const getGroupVoteMax = (selectedGroups, voteMaxByType, typeGrouping) => {
  const groups =
    selectedGroups && selectedGroups.length ? selectedGroups : Object.keys(typeGrouping);
  const types = groups.flatMap((g) => typeGrouping[g] || []);
  const max = types.reduce((m, t) => Math.max(m, voteMaxByType[t] ?? 0), 0);
  return max > 0 ? max : 50000;
};

// Proportionally rescale the votes floor when the media type's ceiling changes,
// preserving relative selectivity, then snap to the new step and clamp to max.
export const rescaleVotes = (curVotes, oldMax, newMax) => {
  const step = niceVoteStep(newMax);
  const rescaled = oldMax > 0 ? Math.round((curVotes * newMax) / oldMax) : 0;
  return Math.min(newMax, Math.round(rescaled / step) * step);
};
